import React from "react";
import { useEffect, useRef, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Divider,
  makeStyles,
  Typography,
  Button,
  TextField,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  CircularProgress,
  Modal,
} from "@material-ui/core";
import { gpColors } from "../../../constants/colors";
import SideDrawer from "../Drawer";
import PlayBeepSound from "./PlayBeepSound";
import { Html5QrcodeScanner } from "html5-qrcode";
import { getCookie } from "../../../Functions";
import CryptoAES from "crypto-js/aes";
import CryptoENC from "crypto-js/enc-utf8";
import { set } from "lodash";
import { useLocation } from "react-router-dom";
import { routes } from "../../../constants/routes";
import DataTable from "react-data-table-component";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import Cookies from "js-cookie";
import api from "../../Interceptors/axiosInstance";
import AddProductValMOdal from "../AddProductValMOdal";

const useStyles = makeStyles((theme) => ({
  roots: {
    display: "flex",
    height: "auto",
    minHeight: "100vh",
    backgroundColor: "#EAE4E8",
  },
  content: {
    width: "100%",
    width: "100%",
    flexGrow: 1,
    paddingTop: "84px",
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  title: {
    fontSize: "20px",
    fontWeight: 600,
    paddingBottom: 20,
  },
  root: {
    padding: "3%",
    minHeight: "280px",
    marginTop: "20px",
  },
  textFieldStyle: {
    width: "60%",
    height: "50px",
    [theme.breakpoints.only("sm")]: {
      width: "70%",
    },
    [theme.breakpoints.down("xs")]: {
      width: "100% !important",
    },
    "& .MuiOutlinedInput-root": {
      height: "50px",
    },
  },
  scanLocScanBoxRow: {
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      flexDirection: "column",
      gap: "350x",
      flexDirection: "column",
      gap: "350x",
    },
  },
  scanBox: {
    [theme.breakpoints.down("sm")]: {
      width: "100% !important",
    },
  },
  locScanTable: {
    [theme.breakpoints.down("sm")]: {
      width: "100% !important",
    },
  },
  scanButton: {
    backgroundColor: gpColors.logoBrown,
    color: "#fff !important",
    // width: "15%",
    "&.MuiButtonBase-root": {
      "&:hover": { backgroundColor: gpColors.logoBrown },
    },
    [theme.breakpoints.only("sm")]: {
      width: "45%",
    },
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
  },
  qrBoxContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "left",
    alignItems: "left",
  },
  scanner: {
    width: "90%",
    marginTop: "5%",
    position: "unset !important",
    [theme.breakpoints.only("sm")]: {
      width: "100%",
    },
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
  },
  exportButton: {
    backgroundColor: gpColors.logoBrown,
    color: "#fff",
    marginBottom: "12px",
    width: "15%",
    "&.MuiButtonBase-root": {
      "&:hover": { backgroundColor: gpColors.logoBrown },
    },
    [theme.breakpoints.down("sd")]: {
      width: "60%",
    },
  },
  editLink: {
    color: "rgb(23, 94, 170)",
    cursor: "pointer",
    textDecoration: "none",
    fontSize: "0.875rem",
    fontWeight: "bold",
    "&:hover": {
      textDecoration: "underline",
    },
  },
}));

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export const UpdatedInwardScan = () => {
  const classes = useStyles();
  const [scanData, setScanData] = useState([]);
  const [newScan, setNewScan] = useState(0);
  const [loader, setLoader] = useState(false);
  const [totalCBM, setTotalCBM] = useState(null);
  const location = useLocation();
  const [updateModal, setUpdateModal] = useState(false);
  const { partNo, locId, outwardScan, cId } = location.state || {};
  const [selectedRow, setSelectedRow] = useState(null);
  const [originalScanData, setOriginalScanData] = useState([]);
  const [orignalScan, setOrignalScan] = useState(0);
    const [validationModal, setValidationModal] = useState(false);
   function closeValidationModal() {
    setValidationModal(false);
  }
  const [alert, setAlert] = useState({
    alertStatus: false,
    alertMessage: "",
    alertColor: "",
  });

  // Alert box close
  const handleAlertClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlert({
      ...alert,
      alertStatus: false,
      alertColor: "",
      alertMessage: "",
    });
  };
  const [search, setSearch] = useState("");
  useEffect(() => {
    showInwardScans();
  }, []);

  const showInwardScans = async () => {
    try {
      const apiUrl = outwardScan ? "getOutwardScanByPartNoAndLocId" : "getInwardScanByPartNoAndLocId";
      setLoader(true);
      const resp = await api.get(apiUrl, {
        params: {
          partNo: partNo.trim(),
          locationId: locId,
          cId: cId ? cId : 0,
        },
      });
      const data = resp.data;
      if (data.result === "success") {
        const resultData = data.resultData;
        if (Array.isArray(resultData) && resultData.length > 0) {
          setScanData(resultData);
          setOriginalScanData(resultData);
        } else {
          setScanData([]);
        }
        setTotalCBM(data.totalCBM);
        setLoader(false);
      }
    } catch (e) {
      console.log("getInwardStockList Error :- ", e);
      setAlert({
        alertStatus: true,
        alertMessage: "Something went wrong please try after some time",
        alertColor: "red",
      });
    }
  };
  const filteredData = scanData?.filter(
    (item) =>
      item.scanDate?.toString().toLowerCase().includes(search.toLowerCase()) ||
      item.scannedBy?.toString().toLowerCase().includes(search.toLowerCase()) ||
      String(item.scans).includes(search) ||
      String(item.cbm).includes(search)
  );
  const columns = [ 
    {
      name: "Scan Date",
      selector: (row) => (row.scanDate ? row.scanDate : "NA"),
      sortable: true,
      center: true,
    },
    {
      name: "Last Scanned By",
      selector: (row) => (row.scannedByUser ? row.scannedBy : "NA"),
      sortable: true,
      center: true,
    },
    {
      name: "No. of Scans",
      selector: (row) => row.scans,
      sortable: true,
      center: true,
      cell: (row, index, column, id) => (
        <input
          type="number"
          inputProps={{ min: 0 }}
          //   value={row.scans}
          value={scanData.find((r) => r.id === row.id)?.scans ?? 0}
          onChange={(e) => handleScanChange(e, row.id, row.scans)}
          style={{ width: "60px", textAlign: "center" }}
        />
      ),
    },

    {
      name: "CBM",
      selector: (row) => row.cbm,
      sortable: true,
      center: true,
    },
    {
  name: "Action",
  cell: (row) => {
    const current = scanData.find(r => r.id === row.id)?.scans ?? 0;
    const original = originalScanData.find(r => r.id === row.id)?.scans ?? 0;
    return (
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: "center",
          gap: 10,
        }}
      >
        <button
          onClick={() => handleUpdateScan(row, original)}
          disabled={current === original} 
        >
          Save
        </button>
      </Box>
    );
  },
  ignoreRowClick: true,
  allowOverflow: true,
  button: true,
  center: true,
},

    // {
    //   name: "Action",
    //   cell: (row) => (
        
    //     <Box
    //       sx={{
    //         display: "flex",
    //         flexWrap: "wrap",
    //         justifyContent: "center",
    //         alignItems: "center",
    //         gap: 10,
    //       }}
    //     >
    //       <button
    //         // className={classes.editLink}
    //         onClick={() => handleUpdateScan(row)}
    //         disabled ={row.scans }
    //       >
    //         Save
    //       </button>
    //     </Box>
    //   ),
    //   ignoreRowClick: true,
    //   allowOverflow: true,
    //   button: true,
    //   center: true,
    // },
  ];

  function roundSQLStyle(num, decimals = 2) {
  const factor = Math.pow(10, decimals);
  return Math.round((num + Number.EPSILON) * factor) / factor;
}

  const handleScanChange = (e, rowId, oldScan) => {
    console.log('oldScan: ', oldScan)
    const value = Number(e.target.value);
    console.log("value: ", value, " rowId: ", rowId);
    if (isNaN(value) || value < 0) {
      return;
    }
    setScanData((prevData) => {
      const existing = prevData.find((r) => r.id === rowId);
      if (existing) {
        return prevData.map((r) =>
          r.id === rowId ? { ...r, scans: value, cbm: roundSQLStyle(value * r.orignalCbm, 2) } : r 
          // r.id === rowId ? { ...r, scans: value, cbm: value * r.orignalCbm } : 
        );
      } 
    });
  };

  const handleUpdateScan = (row, original) => {
    console.log("Edit clicked for row:", row.scans, original);
    setOrignalScan(original);
    setNewScan(row.scans);
    setUpdateModal(true);
    setSelectedRow(row);
  };

  const handleScanCount = async () => {
    try {
      setUpdateModal(false);
      const apiUrl = outwardScan ? "updateOutwardScan" : "updateInwardScan";
      const diff = newScan - orignalScan;
      console.log('diff: ', diff);
      const resp = await api.post(apiUrl, { id: selectedRow.id,
        scansCount: selectedRow.scans,
        userId: selectedRow.scannedByUserId,
        partNo: partNo,
        shipToLocId: locId,
        containerId: cId ? cId : 0,
        noOfPcs :diff
      });
      const data = resp.data;
      if (data.result === "success") {
        setAlert({
          alertStatus: true,
          alertColor: "green",
          alertMessage: "Scans updated successfully",
        });
        showInwardScans();
      } else {
        console.log("Error in updating scans: ", data.resultMessage);
        setAlert({
          alertStatus: true,
          alertColor: "red",
          alertMessage: data.resultMessage || "Failed to update scans",
        });
      }
    setUpdateModal(false);
    } catch (e) {
      console.log("updateInwardScans Error :- ", e);
      setAlert({
        alertStatus: true,
        alertMessage: "Something went wrong please try after some time",
        alertColor: "red",
      });
    }
  };
  return (
    <Box className={classes.roots}>
      <SideDrawer tabName="scan" />
      <main className={classes.content}>
        <Box style={{ display: "flex", justifyContent: "space-between" }}>
          <Typography className={classes.title}>All Inward Scans</Typography>
          {/* <Button className={classes.exportButton}>Export</Button> */}
        </Box>

        <Divider />
        <Card className={classes.root}>
          <CardContent mt={0}>
            {/* stock list  */}
            <Box mt={0}>
              <div style={{ padding: "20px" }}>
                <Box
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "20px",
                  }}
                >
                  {/* {totalCBM && ( */}
                  <Typography style={{ fontSize: "20px", fontWeight: 600 }}>
                    Total CBM - &nbsp;&nbsp; {totalCBM ? totalCBM : 0}
                  </Typography>
                  {/* Search Bar */}
                  <input
                    type="text"
                    placeholder="Search..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    style={{
                      marginBottom: "10px",
                      padding: "10px",
                      width: "300px",
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                    }}
                  />
                </Box>
                {/* Data Table */}
                <Box sx={{ borderRadius: 2, overflow: "hidden" }}>
                  <DataTable
                    columns={columns}
                    data={filteredData || []}
                    progressPending={loader}
                    progressComponent={
                      <CircularProgress size={30} color="inherit" />
                    }
                    noDataComponent={
                      <div style={{ color: "red" }}>Data Not Exist</div>
                    }
                    pagination
                    paginationPerPage={10}
                    paginationRowsPerPageOptions={[5, 10, 20, 50, 100]}
                    highlightOnHover
                    striped
                    responsive
                    persistTableHead
                    customStyles={{
                      headCells: {
                        style: {
                          backgroundColor: gpColors.logoGray,
                          color: "#fff",
                          fontWeight: "bold",
                          justifyContent: "center",
                        },
                      },
                      rows: {
                        style: {
                          fontSize: "0.875rem",
                        },
                      },
                    }}
                  />
                </Box>
              </div>
            </Box>
          </CardContent>
        </Card>
      </main>
 <AddProductValMOdal
        validationModal={validationModal}
        closeValidationModal={closeValidationModal}
        handleAlertClose={handleAlertClose}
        alert={alert}
      />
      <Modal
        open={updateModal}
        onClose={() => setUpdateModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
         <Typography id="modal-modal-description" sx={{ mt: 2 }}>
  Are you sure you want to update the scans from <strong style={{color: "red"}}>{orignalScan}</strong> to <strong style={{color: "red"}}>{newScan}</strong>?
</Typography>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mt: 4,
              gap: "20px",
            }}
          >
            <Button
              variant="contained"
              color="default"
              className="dragDialogBtn"
              onClick={() => setUpdateModal(false)}
            >
              Cancel
            </Button>
            {/* <Button variant='contained' color='error'  onClick={handleDeleteUser}>Delete</Button> */}
            <Button
              variant="contained"
              color="secondary"
              onClick={handleScanCount}
            >
              Update{" "}
            </Button>
          </Box>
        </Box>
      </Modal>

    </Box>
  );
};
